// @flow strict
import React from 'react'
import { graphql } from 'gatsby'
/* TODO: Consider moving this component (and all it's many many bits) into 
a lib that both apps can import from rather than one app importing another.05

This seems to be working for now and this is a timeboxed exercise so will need
to revisit during the next timebox.
*/
import FeaturePage, {
  type Props,
} from '../../../app.features/src/templates/FeaturePage'

const USFeaturePage = (props: Props) => <FeaturePage {...props} />

export default USFeaturePage

/***************************
 *          QUERY
 ***************************/

export const query = graphql`
  query singleFeaturePage($id: String!) {
    contentfulCmsFeaturePage(id: { eq: $id }) {
      webSlug
      title
      ogImage {
        file {
          url
        }
      }
      ogDescription {
        ogDescription
      }
      contentSections {
        content: json
      }
      canonicalURL
      theme
    }
  }
`
